export const fieldForms = () => {
  return {
    form_name_placeholder: 'Ingresa el nombre del formulario',
    description_placeholder: 'Escribe una descripción corta',
    description: 'Descripción',
    form_name: 'Nombre del formulario',
    field_forms: 'Formularios de campo',
    next: 'Siguiente',
    work_order_assignment: 'Asignación de órdenes de trabajo',
    assignment_tip: `Es importante asociar un formulario de campo a las órdenes de trabajo que
    crear y enviar. La lista de oficios, servicios y tipos son
    extraiga directamente de su sistema WOM. La aplicación asegurará
    no tiene formularios de campo duplicados por oficio, servicio y
    tipo.`,
    select_trade: 'Seleccionar Categoria',
    select_service: 'Seleccionar Servicio',
    select_type: 'Seleccionar Typo',
    default: 'Por defecto',
    cancel: 'Cancelar',
    column_names: {
      form_name: 'Nombre del Formulario',
      status: 'Estado',
      last_edit_date: 'Última fecha de edición',
      edited_by: 'Editado por',
      trade: 'Categoria',
      service: 'Servicio',
      type: 'Typo de Work Order',
      actions: 'Acciones'
    },
    sort_menu: {
      sort: 'Ordenal',
      clear: 'Limpiar',
      highest: 'Mayor',
      lowest: 'Menor',
      oldest: 'Más viejo',
      newest: 'Más nuevo'
    }
  }
}
